<template>
  <div class="distributor-system-set">
    <div class="common-header-wrap">
      <mt-header :title="$t('distributor.title.configuration')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div>
      <div class="form-wrapper">
<!--         <mt-cell title="新单铃声提醒" >
          <mt-switch v-model="new_order_ring_remind"/>
        </mt-cell>
        <mt-cell v-if="if_shock" title="新单震动提醒" >
          <mt-switch v-model="new_order_shock_remind"/>
        </mt-cell> -->
<!--         <mt-cell title="催单铃声提醒" >
          <mt-switch v-model="urge_order_ring_remind"/>
        </mt-cell>
        <mt-cell title="催单震动提醒" >
          <mt-switch v-model="urge_order_shock_remind"/>
        </mt-cell> -->
      </div>
      <div class="form-wrapper main-content">
    		<!-- <flex-line :show-border="true">
    		<span>{{ $t('distributor.account.occupy_setting') }}</span>
    		<div slot="right">
    		  <mt-radio
    				  v-model="accept_order_type"
    				  :options="accept_order_options">
    		  </mt-radio>
    		</div>
    		</flex-line> -->
    		<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">{{ $t('distributor.account.occupy_limit') }}</span><div class="field-line-right" slot="right"><input class="field-input" v-model="auto_accept_order_top_limit" /></div></flex-line>
      </div>
    </div>
    <div class="notice">
      <p>{{ $t('distributor.account.occupy_limit_notice', [current_occupy_limit]) }}</p>
    </div>
	<div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="updateSet">{{ $t('general.save') }}</div></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import { updateUserSet } from '../../../api/distributorUser'
import flexLine from '../../flexLine'
export default {
  components: {
	flexLine
  },
  name: 'DistributorSystemSet',
  data () {
    return {
      accept_order_type: '0',
      accept_order_options: [
        {
          label: this.$t('distributor.account.manual_occupy'),
          value: '0'
        },
        {
          label: this.$t('distributor.account.auto_occupy'),
          value: '1'
        }
      ],
      new_order_ring_remind: true,
			new_order_shock_remind: true,
			urge_order_ring_remind: true,
			urge_order_shock_remind: true,
      auto_accept_order_top_limit: 0,
      if_shock:navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate
    }
  },
  mounted () {

  },
  computed: {
    ...mapState({
      user: state => state.distributor.info,
      system_occupy_limit: state => state.config.config.o2o_distributor_receipt_limit
    }),
    current_occupy_limit: function() {
      let limit = this.system_occupy_limit
      // if (this.system_occupy_limit == 0)
      //   limit = this.auto_accept_order_top_limit
      // else
      //   limit = Math.min(this.system_occupy_limit, this.auto_accept_order_top_limit)

      if (limit == 0)
        return '不限'
      else
        return limit
    }
  },
  created: function () {
		if(this.user){
			this.new_order_ring_remind=this.user.new_ring?true:false
			this.new_order_shock_remind=this.user.new_shock?true:false
			this.urge_order_ring_remind=this.user.urge_ring?true:false
			this.urge_order_shock_remind=this.user.urge_shock?true:false
			this.auto_accept_order_top_limit=this.user.receipt_limit
			this.accept_order_type=String(this.user.auto_receipt)
		}
  },

  methods: {
    ...mapMutations({
      distributorEdit: 'distributorEdit',

    }),
		updateSet(){
      if (parseInt(this.system_occupy_limit) !== 0 && this.auto_accept_order_top_limit > this.system_occupy_limit)
        this.auto_accept_order_top_limit = this.system_occupy_limit

			let data={
						new_ring:this.new_order_ring_remind?1:0,
						new_shock:this.new_order_shock_remind?1:0,
						urge_ring:this.urge_order_ring_remind?1:0,
						urge_shock:this.urge_order_shock_remind?1:0,
						receipt_limit:this.auto_accept_order_top_limit,
						auto_receipt:parseInt(this.accept_order_type),
					}
			updateUserSet(data.new_ring,data.new_shock,data.urge_ring,data.urge_shock,data.receipt_limit,data.auto_receipt).then(res => {
          this.distributorEdit(data)
					Toast(res.message)
        }).catch(function (error) {
          Toast(error.message)
        })
		},
  }
}
</script>
<style  lang="scss" scoped>
	.main-content{background: #fff;padding:0 $pageSpace}
  .distributor-system-set {
    background: #fff;
    .form-wrapper {
      border-bottom: 1px solid #eee;
      .mint-field-core {
        text-align: right;
      }
      .mint-switch-input:checked + .mint-switch-core {
        border-color: #ff9900 !important;
        background-color: #ff9900 !important;
      }
      .mint-radiolist-title {
        margin: 0 !important
      }
      .mint-radiolist {
        display: flex;
        .mint-cell {
          flex: 1;
          .mint-radio-input:checked + .mint-radio-core {
            background-color: #ff9900 !important;
            border-color: #ff9900 !important;
          }
        }
      }
    }
    .notice {
      font-size: .6rem;
      color: #999;
      padding: .5rem;
      p {
        position: relative;
        padding-left: .5rem;
      }
      p::before {
        position: absolute;;
        content: '';
        width: .3rem;
        height: .3rem;
        border-radius: 50%;
        background: #ddd;
        display: block;
        top: 50%;
        margin-top: -.15rem;
        left: -.25rem
      }
    }
  }

</style>
